import { filtraMenu, gruppiDaAprire, trovaPerRoute, vociNavigabili, type VoceMenu } from "~/utils/menu";

// Logica della sidebar senza DOM né router: ricerca nel menu, gruppi aperti e invio sul risultato. Il componente le passa il menu
// (già normalizzato), la route attiva e la funzione che traduce le etichette.
export function useSidebar(voci: Ref<VoceMenu[]>, routeAttiva: Ref<string>, traduci: (chiave: string) => string) {
  const ricerca = ref("");
  const espansi = ref<Record<string, boolean>>({});

  const vociFiltrate = computed(() => filtraMenu(voci.value, ricerca.value, traduci));
  const risultati = computed(() => vociNavigabili(vociFiltrate.value));

  function alternaGruppo(chiave: string): void {
    espansi.value = { ...espansi.value, [chiave]: !espansi.value[chiave] };
  }

  // Apre tutta la catena di gruppi che contiene la route attiva
  function apriCatenaAttiva(): void {
    const trovata = trovaPerRoute(routeAttiva.value, voci.value);
    if (!trovata) return;
    const aperti = { ...espansi.value };
    trovata.antenati.forEach((antenato) => (aperti[antenato.key] = true));
    espansi.value = aperti;
  }

  // Cercando si aprono i gruppi che contengono i risultati
  watch(ricerca, (testo) => {
    const daAprire = gruppiDaAprire(voci.value, testo, traduci);
    if (!daAprire.length) return;
    espansi.value = { ...espansi.value, ...Object.fromEntries(daAprire.map((chiave) => [chiave, true])) };
  });

  watch(routeAttiva, apriCatenaAttiva);

  // Invio nel campo di ricerca: se resta una sola destinazione la restituisce (e azzera la ricerca), altrimenti null
  function invioRicerca(): string | null {
    const unico = risultati.value.length === 1 ? risultati.value[0] : undefined;
    if (!unico?.route) return null;
    ricerca.value = "";
    return unico.route;
  }

  return { ricerca, espansi, vociFiltrate, risultati, alternaGruppo, apriCatenaAttiva, invioRicerca };
}
